import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";
import {
    FaShieldAlt,
    FaLock,
    FaUserSecret,
    FaCookieBite,
    FaInfoCircle
} from "react-icons/fa";

export default function PrivacyPolicy() {
    return (
        <div className="w-full bg-gradient-to-b from-orange-50 to-white">

            {/* HERO */}
            <Hero
                variant="inner"
                title="Privacy Policy"
                subtitle="Your privacy matters to us. Here's how we protect your data."
                backgroundImage={hotelImg}
            />

            {/* MAIN */}
            <div className="max-w-6xl mx-auto px-4 py-20 grid md:grid-cols-4 gap-10">

                {/* SIDEBAR */}
                <div className="md:col-span-1">
                    <div className="sticky top-24 bg-white rounded-2xl shadow-lg border border-orange-100 p-5 space-y-4">
                        <h3 className="font-semibold text-[#0F172A] mb-2">Quick Links</h3>

                        {[
                            "Introduction",
                            "Information We Collect",
                            "How We Use Data",
                            "Security",
                            "Sharing",
                            "Cookies",
                            "Your Rights",
                            "Contact"
                        ].map((item, i) => (
                            <a
                                key={i}
                                href={`#section-${i}`}
                                className="block text-sm text-gray-600 hover:text-[#0F172A] transition"
                            >
                                {item}
                            </a>
                        ))}
                    </div>
                </div>

                {/* CONTENT */}
                <div className="md:col-span-3 space-y-8">

                    {/* CARD WRAPPER */}
                    <div className="bg-white rounded-2xl shadow-lg p-8 space-y-10">

                        {/* Section */}
                        <Section
                            id="section-0"
                            icon={<FaInfoCircle />}
                            title="Introduction"
                            text="We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data."
                        />

                        <Section
                            id="section-1"
                            icon={<FaUserSecret />}
                            title="Information We Collect"
                            list={[
                                "Personal details (name, email, phone)",
                                "Booking and travel preferences",
                                "Payment information (secured)",
                                "Usage data (cookies, analytics)"
                            ]}
                        />

                        <Section
                            id="section-2"
                            icon={<FaInfoCircle />}
                            title="How We Use Your Information"
                            list={[
                                "Process bookings and payments",
                                "Improve user experience",
                                "Send confirmations",
                                "Provide customer support"
                            ]}
                        />

                        <Section
                            id="section-3"
                            icon={<FaLock />}
                            title="Data Security"
                            text="We use advanced encryption and secure systems to protect your data at all times."
                        />

                        <Section
                            id="section-4"
                            icon={<FaShieldAlt />}
                            title="Sharing of Information"
                            text="We never sell your data. We only share it with trusted partners when necessary."
                        />

                        <Section
                            id="section-5"
                            icon={<FaCookieBite />}
                            title="Cookies"
                            text="We use cookies to enhance your experience. You can control them via browser settings."
                        />

                        <Section
                            id="section-6"
                            icon={<FaUserSecret />}
                            title="Your Rights"
                            text="You can access, update, or delete your data anytime by contacting us."
                        />

                        <Section
                            id="section-7"
                            icon={<FaInfoCircle />}
                            title="Contact Us"
                            text="Reach out to our support team for any privacy-related questions."
                        />

                    </div>
                </div>
            </div>
        </div>
    );
}

/* Reusable Section Component */
function Section({ id, icon, title, text, list }) {
    return (
        <div id={id} className="scroll-mt-24">

            <div className="flex items-center gap-3 mb-3">
                <div className="text-[#0F172A] text-xl">{icon}</div>
                <h2 className="text-xl font-semibold text-[#0F172A]">
                    {title}
                </h2>
            </div>

            {text && (
                <p className="text-gray-600 text-sm leading-relaxed">
                    {text}
                </p>
            )}

            {list && (
                <ul className="list-disc pl-5 text-gray-600 text-sm space-y-1">
                    {list.map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
}